import { expenseDeleteApi } from "../../api/expense/expenseDeleteApi"

type PayloadShape = Parameters<typeof expenseDeleteApi>[0]

export async function expenseDeleteService(payload: PayloadShape, token: string) {
	return await expenseDeleteApi(payload, token)
}
